<template>
  <v-dialog v-model="dialogShow" persistent width="800" class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">打开文件</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="height:579px;padding:24px 0 0 0;font-size:14px;color:#000000;">
        <!--搜索栏-->
        <div style="padding-right:30px;display:flex;">
          <v-spacer></v-spacer>
          <div style="position:relative;">
            <v-text-field v-model="searchKeyword" @keyup.enter.native="getMySceneFolderList(1)"
                          autocomplete="off" dense outlined placeholder="搜索" hide-details class="sceneSearchTextField">
            </v-text-field>
            <div style="position:absolute;top:10px;left:15px;width:16px;height:16px;">
              <p style="font-size:16px;font-weight:bold;cursor:pointer;" class="iconfontFamily">&#xe630;</p>
            </div>
            <div @click="clearSearchKeyword" v-if="searchKeyword!==''" style="position:absolute;top:12px;right:15px;width:16px;height:16px;cursor:pointer;">
              <p style="line-height:18px;font-size:18px;color:#c4c4c4;" class="iconfontFamily">&#xe632;</p>
            </div>
          </div>
        </div>

        <!--文件列表-->
        <div style="padding-top:9px;">
          <div style="border-bottom:1px solid #e5e5e5;font-weight:bold;display:flex;">
            <p style="padding-left:112px;line-height:42px;flex:1;">项目名称</p>
            <p style="width:303px;line-height:42px;">最后修改时间</p>
          </div>
          <div style="height:370px;padding:0 30px;overflow:auto;" class="myScrollArea">
            <div @click="currChooseFolderId = item.recordId" v-for="(item,index) in myFolderInfo.folderList" :key="index"
                 :style="{'background':currChooseFolderId === item.recordId ? 'rgba(42, 130, 228, 0.2)' : ''}" class="folderListItem">
              <p :style="{'visibility':item.recordId === $store.state.currSceneFolderId ? 'visible' : 'hidden'}" style="margin-left:20px;line-height:46px;color:#2A82E4;">编辑中</p>
              <p style="padding-left:20px;line-height:46px;flex:1;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.recordName}}</p>
              <p style="width:235px;line-height:46px;">{{item.gmtModifytime.slice(0,10)}}</p>
              <p @click="deleteSceneFolder(item)" :style="{'visibility':item.recordId === $store.state.currSceneFolderId ? 'hidden' : ''}"
                 class="deleteSceneBtn iconfontFamily">&#xe720;</p>
            </div>
          </div>
          <div style="margin-top:26px;padding:0 30px;display:flex;align-items:center;">
            <v-spacer></v-spacer>
            <!--页码-->
            <page-number v-show="myFolderInfo.totalPageNum > 1" :totalPageNum="myFolderInfo.totalPageNum" :currPageNum="myFolderInfo.currPageNum" @changePageNumber="getMySceneFolderList"></page-number>
            <v-spacer></v-spacer>
            <v-btn @click="chooseFolder" width="100" height="35" dark :color="currChooseFolderId!==''&&currChooseFolderId!==$store.state.currSceneFolderId ? '#1E3A8A' : 'rgba(30, 58, 138, 0.5)'">打开</v-btn>
          </div>
        </div>

      </v-card-text>
    </v-card>



    <!--打开文件丢失内容提示弹窗-->
    <v-dialog v-model="oldFolderCloseDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="oldFolderCloseDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="tipsDialog-mainArea">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">打开其他文件会失去当前未保存内容，是否继续？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="oldFolderCloseDialogShow = false" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="oldFolderCloseOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--删除文件提示弹窗-->
    <v-dialog v-model="deleteFolderDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="deleteFolderDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="tipsDialog-mainArea">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">文件删除后将无法恢复<br/>确定删除？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="deleteFolderDialogShow = false" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="deleteFolderOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>



  </v-dialog>
</template>

<script>
import PageNumber from '/src/components/page_number/PageNumber';

export default {
  name: "ChooseSceneFolder",
  components: {
    PageNumber
  },
  props:["dialogShow"],

  data(){
    return{

      currChooseFolderId:"",

      searchKeyword:"",

      myFolderInfo:{
        folderList:[],
        totalPageNum:0,
        currPageNum:1,
      },

      //离开旧文件夹弹窗
      oldFolderCloseDialogShow:false,

      //删除文件提示弹窗
      deleteFolderItem:"",
      deleteFolderDialogShow:false,


    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },

    //我的文件
    getMySceneFolderList(pageNum){
      this.$axios({
        method:"get",
        url:"/authorApi/z-screen-recorder/recordList",
        params:{
          curPageNum:pageNum,
          maxResultNum:10,
          keyWord:this.searchKeyword
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.currChooseFolderId = "";
          this.myFolderInfo.folderList = resultData.data.list;
          this.myFolderInfo.currPageNum = pageNum
          this.myFolderInfo.totalPageNum = resultData.data.totalPageNum;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //清空搜索
    clearSearchKeyword(){
      this.searchKeyword = "";
      this.getMySceneFolderList(1)
    },


    //删除文件夹
    deleteSceneFolder(item){
      console.log(item)

      this.deleteFolderItem = item;
      this.deleteFolderDialogShow = true;

    },
    deleteFolderOK(){
      this.$axios({
        method:"post",
        url:"/authorApi/z-screen-recorder/deleteRecord",
        params:{
          recordId:this.deleteFolderItem.recordId,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.deleteFolderDialogShow = false;
          if(this.currChooseFolderId === this.deleteFolderItem.recordId){
            this.currChooseFolderId = "";
          }
          let index  = this.myFolderInfo.folderList.indexOf(this.deleteFolderItem)
          if(index !== -1){
            this.myFolderInfo.folderList.splice(index,1)
          }
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });


    },



    //确定选择文件夹
    chooseFolder(){
      if(this.currChooseFolderId!=='' && this.currChooseFolderId!==this.$store.state.currSceneFolderId){
        //选择了要打开的文件
        if(this.$store.state.globeQuitShowDialog){
          this.oldFolderCloseDialogShow = true;
        }
        else{
          this.$emit("chooseSceneFolderOk",this.currChooseFolderId)
        }
      }
    },
    oldFolderCloseOK(){
      this.oldFolderCloseDialogShow = false;
      this.$emit("chooseSceneFolderOk",this.currChooseFolderId)
    },




  },
  mounted(){
    this.getMySceneFolderList(1);

  }

}
</script>

<style scoped>

.folderListItem{
  height:44px;
  border-bottom:1px solid #e5e5e5;
  display:flex;
  cursor:pointer;
}
.folderListItem:hover{
  background:rgba(42, 130, 228, 0.2);
}


.deleteSceneBtn{
  margin-right:22px;
  line-height:46px;
  font-size:16px;
  visibility: hidden;
}
.folderListItem:hover .deleteSceneBtn{
  visibility: visible;
}


.sceneSearchTextField{
  width:400px;
  color:#000000;
}


</style>

<style>

.sceneSearchTextField .v-text-field__slot{
  margin-left:30px;
}

.sceneSearchTextField .v-text-field__slot input{
  max-width:300px;
  color:#000000;
}


</style>

